import React from 'react';
import styled from 'styled-components/macro';
import { Grid, TextField, Snackbar } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const DisplayFieldHorizontal = props => {
  const { label, value, displayChange, displayStatus } = props;
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);

  const handleClick = async (value) => {
    setOpen(true);
    await navigator.clipboard.writeText(value);
  };

  return (
    <Wrapper>
      <Grid container>
        <Grid item xs={5} lg={5} className="display-label">
          {t(label)}:
        </Grid>
        <Grid item xs={7} lg={7} className={`${(displayChange) && 'highlight-pending'}
                                              ${(displayChange && displayStatus === 'complete') && 'highlight-complete'}`}>
          <TextField
            value={value}
            multiline
            variant="outlined"
            InputProps={{
              readOnly: true,
              style: { fontSize: 12 },
              onClick: () => handleClick(value)
            }}
          />
          <Snackbar
            message="Copied to clipboard"
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            autoHideDuration={2000}
            onClose={() => setOpen(false)}
            open={open}
          />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  margin: 0 5px;
  //pointer-events: none;
  .display-label {
    display: flex;
    align-items: center;
  }
  .MuiFormControl-root {
    display: flex;
  }
  .MuiOutlinedInput-root {
    padding: 5px;
  }
  .highlight-pending {
    background-color: ${p => p.theme.pending};
  }
  .highlight-complete {
    background-color: ${p => p.theme.complete};
  }
`;
